import { ViewModel,View } from "binder"
import  { FormBuilderPartView } from "./formBuilderPart-view"

export class FormBuilderPartViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel,name:string,content:ViewModel) {
        super(parentViewModel);

        this.name = name;
        this.content = content;
    }
    GetDefaultView(): View <ViewModel> {
        return new FormBuilderPartView();
    }
    public getTypeId(): string {
        return "VM-3B61F775-4A21-4A54-85A9-E79698A796E7"
    }

    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;

}
